<template>
    <div class="contact-form">
        <iframe src="https://gravaa.odoo.com/contactus" width="100%" height="750" frameborder="0" allowfullscreen></iframe>
    </div>
</template>

<script>
export default {
    data() {
        
    }
};
</script>

<style scoped> 

</style>